// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1joql","footer":"ChangeClinic_footer__-V1e0"};